import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  template: `<mat-card class="m-2">
              <mat-card-header>
                  <mat-card-title>
                      {{title}}
                  </mat-card-title>
                  <mat-card-subtitle>
                      {{subtitle}}
                  </mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                  <ng-content></ng-content>
              </mat-card-content>
            </mat-card>`,
  styles: [`
  /* ::ng-deep .mat-card {
    border-radius: 0px !important;
  } */
  `]
})
export class CardComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;

  constructor() { }

  ngOnInit(): void {
  }

}
